import { useState } from 'react';
import { getData } from '../../utils/api-service';
import { useTranslation } from 'react-i18next';

export default function useDownloadExcel() {
  const [loadingExport, setLoadingExport] = useState(false);
  const { t } = useTranslation();

  const downloadExcel = async (report_url, FileName) => {
    if (loadingExport) {
      return;
    }
    setLoadingExport(true);
    try {
      const res = await getData(
        `${report_url}`,
        null,
        t,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'blob',
        'attachment; filename=[file.csv]'
      );

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${FileName}_${new Date().toISOString()}.xlsx`);
      document.body.appendChild(link);
      link.click();
    } finally {
      setLoadingExport(false);
    }
  };

  const downloadExcelV2 = async (
    reportFetchFunction: () => Promise<{ data: Blob }>,
    FileName: string
  ) => {
    if (loadingExport) {
      return;
    }
    setLoadingExport(true);
    try {
      const res = await reportFetchFunction();
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      try {
        link.href = url;
        link.setAttribute(
          'download',
          FileName.endsWith('.xlsx') ? FileName : `${FileName}_${new Date().toISOString()}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
      } finally {
        link.remove();
        // Let the browser start the download before releasing the blob.
        window.setTimeout(() => window.URL.revokeObjectURL(url), 0);
      }
    } finally {
      setLoadingExport(false);
    }
  };
  return { loadingExport, downloadExcel, downloadExcelV2 };
}
